export const modifyImageResolution = (url: string, resolution: string) => {
	if (!url) return '';
	if (!URL.canParse(url)) return url + `?wid=${resolution}`;

	const _url = new URL(url);
	_url.searchParams.set('wid', resolution);
	return _url.toString();
};
